
import "./style.css";
import React, {useState} from 'react';
import { Grid, Typography, Button, Box, Card, CardContent, CardActions, Checkbox } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';



const Step2 = (props) => {
    const nextnext = () => {
      props.setSelectedType(getSelectedPackageTitle())
      props.nextButton({...props.selectedPost, selectedPackage, packageTitle: getSelectedPackageTitle()})
    }
    const [selectedPackage, setSelectedPackage] = useState(null);
    const getSelectedPackageTitle = () => {
        switch (selectedPackage) {
          case 0:
            return 'Virtual Office';
          case 1:
            return 'Private Office';
          case 3:
            return 'Call Center';
          // Add more cases for other package indices
          default:
            return '';
        }
      };
    const handlePackageClick = (index) => {
        setSelectedPackage(index);
      };
    if (props.currentStep !== 2) {
        return null;
      }

      const renderPackageCard = (index, title, disabled = false) => (
        <Card
          onClick={disabled ? null : () => handlePackageClick(index)}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderColor: selectedPackage === index ? 'primary.main' : 'divider',
            borderWidth: 1,
            borderStyle: 'solid',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <CardContent>
            <Typography variant="h5">{title}</Typography>
          </CardContent>
          {selectedPackage === index && !disabled && (
            <CardActions>
              <CheckCircleOutlineIcon color="primary" />
            </CardActions>
          )}
        </Card>
      );
    return (<Grid container>
                
                
                            
                            <Grid container className="verticalAlign">
                                <Grid lg={2} md={3.5}>
                                    <Typography variant="h6">Klien ID:</Typography>
                                </Grid>
                                <Grid lg={7} md={7.5}>
                                    <Typography>{props.klienID}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container className="verticalAlign">
                                <Grid lg={2} md={3.5}>
                                    <Typography variant="h6">Company ID:</Typography>
                                </Grid>
                                <Grid lg={7} md={7.5}>
                                    <Typography>{props.companyID}</Typography>
                                </Grid>
                            </Grid>
                            
                            <Grid container sx={{mt:5}} className="verticalAlign">
                                <Grid lg={2} md={3.5}>
                                    <Typography variant="h6">Pilih Tipe Kontrak:</Typography>
                                </Grid>
                            </Grid>
                            

                            <Grid container sx={{ mt: 5 }} className="verticalAlign" spacing={2}>
        <Grid item md={4}>
          {renderPackageCard(0, 'Virtual Office', false)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(1, 'Private Office', false)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(2, 'Meeting Room', true)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(3, 'Call Center', false)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(4, 'Legal', true)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(5, 'Pajak/Tax', true)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(6, 'Akutansi/Accounting', true)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(7, 'Merek/HAKI', true)}
        </Grid>
        <Grid item md={4}>
          {renderPackageCard(8, 'Konsultasi/Consultation', true)}
        </Grid>
      </Grid>

      <Grid md={6}>
        <Button sx={{ mt: 5 }} onClick={() => props.prevButton()} size="medium" type="button" variant="contained">Previous</Button>
      </Grid>
      <Grid container md={6} justifyContent="flex-end">
  <Button 
    sx={{ mt: 5 }} 
    onClick={() => {
      const packageTitle = getSelectedPackageTitle();
      if (packageTitle) {
        nextnext({...props.selectedPost, selectedPackage, packageTitle});
      } else {
        console.log("Package title can't be empty.");
      }
    }} 
    size="medium" 
    type="button" 
    variant="contained"
  >
    Next
  </Button>
</Grid>

    </Grid>);};

    export default Step2;
